/**
 * A running duration as `m:ss`, or `h:mm:ss` once it passes an hour.
 *
 * Lives in `lib/` rather than in either tree because both ends of a goon session show the
 * same clock: the operator's remote (`control/screens/Goontroller`) and the wall's own bar
 * (`display/GoonSessionBar`). They had a byte-identical copy each, under two different
 * names, which is the state where one of them quietly gains a fix the other does not.
 */
export function formatElapsed(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${m}:${pad(sec)}`;
}
